fonts = []
remove_fonts = ['Cursive','Fantasy', 'Monospace','Sans-serif','Serif',
  'Arial','Futura','Helvetica Neue', 'Times New Roman','Verdana','Calibri',
  'Cambria', 'Manus', 'Proxima Nova Light', 'Hunkemoller Text', 'Preloslab',
  'StoneSans', 'Dobraslab', 'NN Dagny', 'Trade Gothic', 'Boing Bold',
  'Sentico Sans DT', 'Sentico Sans DT Cond', 'Etelka', 'Poppins', 'Ek Mukta',
  'Raleway', 'Meta', 'NS Sans', 'NS Swift', 'Gotham', 'Franklin Gothic',
  'Galano Grotesque', 'Scala Sans', 'Class Garamond', 'Myriad Pro', 'Aldine721',
  'MMHeadline', 'MMText', 'Mordechay', 'Brix Sans', 'Bebas Neue',
  'Joebob Graphics Manus', 'Mordechay Light', 'Nexa', 'Nexa Light', 'Effra',
  'DIN Pro', 'Beautiful Dreams Brush', 'Loew Black', 'Loew Medium',
  'Museo Sans Black', 'Museo Sans Medium', 'Museo Sans Thin', 'ROsans',
  'Museo Slab Black', 'Museo Slab Medium', 'Museo Slab Thin',
  'Ploni', 'Avant Garde Gothic', 'NN Dagny Text', 'Bonnala', 'Ubuntu Light',
  'Ubuntu Light Italic', 'Bosch Sans Bold', 'Bosch Sans Regular',
  'Bosch Sans Light', 'Imago Pro Boo', 'Imago Pro Med', 'Minion Bold',
  'Minion Regular', 'Ekster Bold', 'Ekster Italic', 'Ekster Medium',
  'Ekster Regular', 'Syntegon Bold', 'Syntegon Italic', 'Syntegon Regular',
  'Neo Regular', 'Neo Light', 'Neo SemiBold', 'PM Extra Light', 'Forma Display Regular',
  'Forma DJR Display Bold', 'Forma DJR Text Regular', 'Ubuntu Bold', 'Ubuntu Regular', 'Ubuntu Medium',
  'RedHat Display Bold', 'RedHat Display Regular', 'Raisonne Book Pro', 'Raisonne DemiBold Pro',
  'Bolder Bold', 'Bolder Heading', 'Bolder Light', 'Bolder Regular', 'Bolder Regular Italic',
  'OpenSans Condensed Bold', 'OpenSans Condensed Light', 'OpenSans Condensed Light Italic',
  'TeleNeo Bold Italic', 'TeleNeo Bold', 'TeleNeo Extra Bold Italic', 'TeleNeo Extra Bold',
  'TeleNeo Medium Italic', 'TeleNeo Medium', 'TeleNeo Regular Italic', 'TeleNeo Regular',
  'TeleNeo Thin Italic', 'TeleNeo Thin', 'TeleNeo Ultra Italic', 'TeleNeo Ultra',
  'RoobertVRT Bold', 'RoobertVRT Heavy', 'RoobertVRT Light', 'RoobertVRT Medium',
  'RoobertVRT Regular', 'RoobertVRT Semibold', 'ROsanswebtextbold', 'ROsanswebtextitalic',
  'Rosanswebtextregular', 'ROserifwebbold', 'ROserifwebitalic', 'ROserifwebregular',
  'Apex Bold', 'Apex Book', 'Apex Medium',
  'Branding Black', 'Branding Bold', 'Branding Light', 'Branding Medium', 'Branding SemiBold',
  'Branding SemiLightItalic', 'Branding Thin', 'GeneralSans Variable', 'GeneralSans VariableItalic',
  'Indian Type Foundry', 'Light Indian Type Foundry', 'Medium Indian Type Foundry',
  'Proximus Bold', 'Proximus Extra Bold', 'Proximus Light', 'Proximus Regular',
  'Paralucent Bold', 'Paralucent Light', 'Paralucent Light Italic',
  'NotoSans Bold Italic', 'NotoSans Bold', 'NotoSans Italic',
  'Europea Bold', 'Europea Bold Italic',
  'Europea Extra Bold', 'Europea Extra Bold Italic',
  'Europea Extra Light', 'Europea Extra Light Italic',
  'Europea Italic', 'Europea Light', 'Europea Light Italic',
  'Europea Medium', 'Europea Medium Italic', 'Europea Regular',
  'Europea Semi Bold', 'Europea Semi Bold Italic',
  'Europea Semi Light', 'Europea Semi Light Italic',
  'ForFuture Sans Light', 'ForFuture Sans', 'ForFuture Sans Medium',
  'ForFuture Sans Bold', 'ForFuture Sans Black'
]

color_to_rgb = (hex) ->
  hex = hex.replace('#', '').toLowerCase()
  red: parseInt(hex.substring(0, 2), 16) / 255
  green: parseInt(hex.substring(2, 4), 16) / 255
  blue: parseInt(hex.substring(4, 6), 16) / 255

relative_lum = (hex) ->
  color = color_to_rgb(hex)
  transform = (channelValue) -> if channelValue <= 0.03928 then channelValue / 12.92 else Math.pow(((channelValue + 0.055) / 1.055), 2.4)
  transform(color.red) * 0.2126 + transform(color.green) * 0.7152 + transform(color.blue) * 0.0722

contrast_ratio = (hex1, hex2) ->
  ratio = (0.05 + relative_lum(hex1)) / (0.05 + relative_lum(hex2))
  ratio = 1 / ratio if ratio < 1
  ratio

better_suggestion = (color) ->
  if relative_lum(color) > 0.5 then 'black' else 'white'

update_contrast_wcag = ->
  titleColor = $('#course_stylesheet_title-color').val()
  descriptionColor = $('#course_stylesheet_description-color').val()
  backgroundColor = $('#course_stylesheet_mobile-background').val()
  backgroundColor = '#ffffff' if !backgroundColor || !/^#[0-9a-fA-F]{6}$/i.test(backgroundColor)
  
  $('#title-wcag-excellent, #title-wcag-good, #title-wcag-poor-black, #title-wcag-poor-white').hide()
  $('#description-wcag-excellent, #description-wcag-good, #description-wcag-poor-black, #description-wcag-poor-white').hide()

  if titleColor && /^#[0-9a-fA-F]{6}$/i.test(titleColor)
    ratio = contrast_ratio(titleColor, backgroundColor)
    $('.title-ratio-value').text(ratio.toFixed(2) + ':1')
    if ratio >= 4.5
      $('#title-wcag-excellent').show()
    else if ratio >= 3
      $('#title-wcag-good').show()
    else
      suggestion = better_suggestion(backgroundColor)
      $("#title-wcag-poor-#{suggestion}").show()
  
  if descriptionColor && /^#[0-9a-fA-F]{6}$/i.test(descriptionColor)
    ratio = contrast_ratio(descriptionColor, backgroundColor)
    $('.description-ratio-value').text(ratio.toFixed(2) + ':1')
    if ratio >= 4.5
      $('#description-wcag-excellent').show()
    else if ratio >= 3
      $('#description-wcag-good').show()
    else
      suggestion = better_suggestion(backgroundColor)
      $("#description-wcag-poor-#{suggestion}").show()



$(document).ready ->
  get_google_fonts($("#course_stylesheet_title-font").val())
  get_google_fonts($("#course_stylesheet_description-font").val())
  get_google_fonts($("#course_stylesheet_answers-font").val())

  update_contrast_wcag()

  $("#course_stylesheet_title-font").change ->
    get_google_fonts($(this).val())
    $('#title-preview').css('font-family', $(this).val())

  $("#course_stylesheet_answers-font").change ->
    get_google_fonts($(this).val())
    $('#answers-preview').css('font-family', $(this).val())

  $("#course_stylesheet_description-font").change ->
    get_google_fonts($(this).val())
    $('#description-preview').css('font-family', $(this).val())

  $('#course_stylesheet_title-size').change ->
    $('#title-preview').css('font-size', $(this).val()+"px")

  $('#course_stylesheet_answers-size').change ->
    $('#answers-preview').css('font-size', $(this).val()+"px")

  $('#course_stylesheet_description-size').change ->
    $('#description-preview').css('font-size', $(this).val()+"px")

  $('#course_stylesheet_title-weight').change ->
    value = $(this).val()
    if $(this).val() == 'Thin'
      value = '100'
    $('#title-preview').css('font-weight', value)

  $('#course_stylesheet_answers-weight').change ->
    value = $(this).val()
    if $(this).val() == 'Thin'
      value = '100'
    $('#answers-preview').css('font-weight', value)

  $('#course_stylesheet_description-weight').change ->
    value = $(this).val()
    if $(this).val() == 'Thin'
      value = '100'
    $('#description-preview').css('font-weight', value)

  $('#course_stylesheet_title-color').change ->
    $('#title-preview').css('color', $(this).val())
    update_contrast_wcag()

  $('#course_stylesheet_answers-color').change ->
    $('#answers-preview').css('color', $(this).val())

  $('#course_stylesheet_description-color').change ->
    $('#description-preview').css('color', $(this).val())
    update_contrast_wcag()

  $('#course_stylesheet_mobile-background').change ->
    $('#title-preview').css('background-color', $(this).val())
    $('#description-preview').css('background-color', $(this).val())
    update_contrast_wcag()
  
  $('.suggest-color').click ->
      color = $(this).data('color')
      if $(this).closest('[id*="title"]').length
        $input = $('#course_stylesheet_title-color')
      else
        $input = $('#course_stylesheet_description-color')
      $input.minicolors('value', color)
      $input.change()

  $('.reset-background-color').click ->
    $(this).parents('.image-edits').find('#select-title-color').minicolors('value', '#ffffff')

  $('.theme-name').click ->
    $(this).hide()
    $(this).next().show()

  $('.theme-name-input').on('keydown', (event) ->
    if(event.keyCode == 13)
      value = $(this).val()
      $(this).hide()
      $(this).prev().html(value)
      $(this).prev().show()
  )

get_google_fonts = (font) ->
  fonts.push font if remove_fonts.indexOf(font) == -1 && font != 'Choose a font'
  if fonts.length > 0
    try
      WebFont.load google: families: fonts
    catch
      # nothing to do